/* tslint:disable */
/* eslint:disable */
/**
* @typedef {Object} workspaceSelectorFormLoadParams

**/
/**
 * Name: Workspace selector - Form load. Evid: 11400.
 * Event description: Workspace selector page loaded - after the user accepts the invitation to join as a collaborator.


 * @param {workspaceSelectorFormLoadParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var workspaceSelectorFormLoad = function (params) {
    return { evid: 11400, src: 5, endpoint: 'login-react-app', params: params };
};
/**
* @typedef {Object} workspaceSelectorUserClickedBackParams

**/
/**
 * Name: Workspace selector - User clicked back. Evid: 11402.
 * Event description: the user clicked back on the workspace selector back to the collaborator invite.


 * @param {workspaceSelectorUserClickedBackParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var workspaceSelectorUserClickedBack = function (params) {
    return { evid: 11402, src: 5, endpoint: 'login-react-app', params: params };
};
/**
* @typedef {Object} workspaceSelectorAccountSelectedParams
* @property {GUID} account_id_selected - the chosen account id
**/
/**
 * Name: Workspace selector - Account selected. Evid: 11401.
 * Event description: After the user accepts the invitation to join as a collaborator, the user chooses with witch account he will join.

 * account_id_selected - Type: guid. Desc: the chosen account id
 * @param {workspaceSelectorAccountSelectedParams} params The parameters for this event.
 * @return {Object} LogObject
**/
export var workspaceSelectorAccountSelected = function (params) {
    return { evid: 11401, src: 5, endpoint: 'login-react-app', params: params };
};
//# sourceMappingURL=index.js.map